import React, { useState } from 'react';
import { withApollo } from 'react-apollo';
import { connect } from 'react-redux';
import { SubmissionError } from 'redux-form';
import omit from 'lodash/omit';
import mapKeys from 'lodash/mapKeys';
import camelCase from 'lodash/camelCase';
import AssignManageForm from 'chameleon-src/components/assign/AssignManageForm';
import { updateResourceSettings } from 'chameleon-src/queries';
import ClassSwitchingInfoModal from 'legacy-src/components/assignment/Assignment/components/ManageForm/ClassSwitchingInfoModal';
import MustAssignInfoModal from 'legacy-src/components/assignment/Assignment/components/ManageForm/MustAssignInfoModal';
import { toast } from 'chameleon/ui-stack/ui/toast';
import ConfirmDialog from 'chameleon/ui-stack/ui/modals/confirm-dialog';

const UpdateResourceSettings = (props) => {
  const {
    assessment,
    assignment,
    onClose,
    client,
    onUpdate,
    onUpdateAssignment,
    closeManageModal,
    individualStudentAssignmentFlag,
  } = props;
  const [selectedAssignment, setSelectedAssignment] = useState(assignment);
  const [showClassSwitchingInfoModal, setShowClassSwitchingInfoModal] =
    useState(false);
  const [showMustAssignInfoModal, setShowMustAssignInfoModal] = useState(false);

  const handleShowClassSwitchingInfoModal = (status = false) =>
    setShowClassSwitchingInfoModal(status);

  const onHandleShowClassSwitchingInfoModal = (event) => {
    handleShowClassSwitchingInfoModal();
    event.preventDefault();
  };

  const handleShowMustAssignInfoModal = (status = false) =>
    setShowMustAssignInfoModal(status);

  const onHandleShowMustAssignInfoModal = (event) => {
    handleShowMustAssignInfoModal();
    event.preventDefault();
  };

  const updateSettings = async (formValues) => {
    const { startsAt, dueAt, students: formStudents } = formValues;
    const sectionId = selectedAssignment.section_id.toString();
    const assignmentId = selectedAssignment.id.toString();
    const newStudentIds = formStudents
      .filter(
        (s) =>
          s.sectionId === sectionId &&
          s.assignmentId === assignmentId &&
          !s.fromOtherISA,
      )
      .map((s) => s.studentId);
    const response = await client.mutate({
      mutation: updateResourceSettings,
      variables: {
        sharedResourceToClassId: selectedAssignment.id.toString(),
        startsAt: startsAt.format(),
        dueAt: dueAt ? dueAt.format() : null,
        newStudentIds,
      },
    });

    const { ok, errors } = response.data.updateResourceSettings;

    if (ok) {
      toast('Video updated successfully', { timeout: 5 });
      if (onUpdate) {
        onUpdate();
      } else {
        onUpdateAssignment();
      }
      closeManageModal();
    } else {
      const submissionErrors = errors.reduce(
        (acc, { fieldName, fieldErrors }) => ({
          ...acc,
          [fieldName]: fieldErrors,
        }),
        {},
      );
      throw new SubmissionError(submissionErrors);
    }
  };

  return (
    <ConfirmDialog
      size="big"
      contentWithSpacing={false}
      title={`Assignment Settings for ${assessment.title}`}
      onClose={onClose}
    >
      {showClassSwitchingInfoModal && individualStudentAssignmentFlag && (
        <ClassSwitchingInfoModal
          onHandleShowClassSwitchingInfoModal={
            onHandleShowClassSwitchingInfoModal
          }
        />
      )}
      {showMustAssignInfoModal && individualStudentAssignmentFlag && (
        <MustAssignInfoModal
          onHandleShowMustAssignInfoModal={onHandleShowMustAssignInfoModal}
        />
      )}
      <AssignManageForm
        {...omit(props, ['assignment', 'assessment', 'videoId', 'videoUnit'])}
        isResourceForm
        isAssign={false}
        item={mapKeys(assessment, (_, key) => camelCase(key))}
        assignment={{
          ...selectedAssignment,
          assignees: [
            {
              id: selectedAssignment.section_id.toString(),
              name: selectedAssignment.section_name,
            },
          ],
        }}
        selectedAssignment={selectedAssignment}
        canUpdateAll={false}
        onAssignmentSelect={setSelectedAssignment}
        onSubmit={updateSettings}
        handleShowClassSwitchingInfoModal={handleShowClassSwitchingInfoModal}
        handleShowMustAssignInfoModal={handleShowMustAssignInfoModal}
        sectionsMinTimezone={selectedAssignment.timezone}
        spacingAroundContent="p-6"
      />
    </ConfirmDialog>
  );
};

const mapStateToProps = ({
  featureFlag: {
    individual_student_assignment: individualStudentAssignmentFlag,
  },
}) => ({
  individualStudentAssignmentFlag,
});

export default withApollo(connect(mapStateToProps)(UpdateResourceSettings));
